import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MonthlySale from "./component/monthly_sale";
import PaymodeSale from "./component/paymodewiseSAle";
import ItemGroupWiseSale from "./component/groupSalereport";
import HourlySale from "./component/hourlySale";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectDate,
  SelectPaymodeStatus,
  setpaymodStatus,
} from "../utility/Redux/refresh";
import FunctionBooking from "./component/functionBooking";

import { ExpandLess, ExpandMore } from "@mui/icons-material";
import TotalSaleComp from "./component/totalSale";
import SectionWiseSale from "./component/sectionWiseSale";
import { setloading } from "../utility/Redux/modal";
import ProfileModal from "../utility/component/modals/profile";
import DayTaxCollacted from "./component/subComponent/datTextCollacted";
import { Collapse } from "@mui/material";
import Deleted from "./component/deleted";
import WeeklySale from "./component/weekly";
import DiscountedBillList from "./component/discountedBill";
const Hotal_res_DashView = ({ prefix }) => {
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(true);
  const dispatch = useDispatch();
  const checkDateData = useSelector(SelectDate);
  var PaymodeStatus = useSelector(SelectPaymodeStatus);

  const ref = useRef(null);

  const RefreshFunction = () => {
    dispatch(setpaymodStatus(Number(PaymodeStatus) + Number(1)));
  };
  const handleClick = () => {
    setOpen(!open);
  };
  useEffect(() => {
    ref.current = setInterval(RefreshFunction, 3 * 60 * 1000);

    return () => {
      if (ref.current) {
        clearInterval(ref.current);
      }
    };
  }, []);

  useEffect(() => {
    dispatch(setloading(true));
  }, [checkDateData]);
  if (!prefix) {
    return "";
  }
  return (
    <div className="restaurant-dashboard">
      <div className="dashboard-hero">
        <div><span className="dashboard-hero-label">TODAY'S SALES</span><div className="dashboard-hero-total"><TotalSaleComp prefix={prefix} /></div><small>Amount collected on selected date</small></div>
        <div className="dashboard-hero-action">
          <span>Tax details</span>
          {open ? (
            <ExpandLess onClick={handleClick} color="secondary" />
          ) : (
            <ExpandMore color="secondary" onClick={handleClick} />
          )}
        </div>
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <div className="dashboard-tax-details"><DayTaxCollacted prefix={prefix} /></div>
      </Collapse>

      <PaymodeSale prefix={prefix} />
      <DiscountedBillList prefix={prefix} />
      <Deleted prefix={prefix} />

      <ItemGroupWiseSale prefix={prefix} />

      <SectionWiseSale prefix={prefix} />

      <HourlySale prefix={prefix} />

      <WeeklySale prefix={prefix} />
      <FunctionBooking prefix={prefix} />
      <MonthlySale prefix={prefix} />
      <ProfileModal prefix={prefix} />
    </div>
  );
};

export default Hotal_res_DashView;
